<template>
    <div>
        <ul class="question-radio grid" :class="[{'with-errors': hasErrors}, columns]">
            <li v-for="(option, index) in question.options" class="flex justify-start items-center | text-lg lg:text-xl" >
                <input type="radio" :id="getOptionId(question,option)" :name="question.id" :value="option.id" v-model="questionAnswer" />
                <label :for="getOptionId(question,option)">
                    {{ option.title }}
                </label>
            </li>
        </ul>
        <div v-if="hasErrors">
            <ul class="text-yellow-700 text-sm">
                <li v-for="error in errors">
                    {{error}}
                </li>
            </ul>
        </div>
    </div>
</template>
<style lang="scss">
.with-errors{
    @apply border-2 border-yellow-500 p-3;
}
.question-radio{
    li{
        @apply pb-2
    }

    input{
        -webkit-appearance: none;
        -moz-appearance: none;
        appearance: none;
        border-radius: 100%;
        width: 16px;
        height: 16px;
        background: #E6E6E6;
        box-shadow: 0px 1px 6px rgb(0 0 0 / 16%);
        border: 3px solid #fff;
        margin-right: 18px;
        cursor: pointer;
        &:checked {
            background: var(--color-primary-light);
            border: 3px solid #fff;
        }
        &:checked + label {
            @apply text-primary-default;
            font-weight: 700;
        }
        &:hover {
            cursor: pointer;
        }
    }

}


</style>
<script>
import { useStore } from 'vuex'
import { computed } from 'vue'

export default {
    name: "RadioQuestion",
    components:{

    },
    data() {
        return {

        }
    },
    mounted() {

    },
    computed: {
        columns(){
            if(this.question.options.length >3 ){
                return 'grid-cols-1 lg:grid-cols-2';
            }
            return 'grid-cols-1';
        },
        questionAnswer: {
            get () {
                return this.$store.getters.answerForQuestion(this.question.id);
            },
            set (value) {
                this.$store.commit('setAnswer', {questionId: this.question.id, answer: value});
            }
        },
        errors: {
            get () {
                return this.$store.getters.errorsForQuestion(this.question.id);
            }
        },
        hasErrors(){
            if(this.errors === null){
                return false;
            }
            return this.errors.length > 0;
        }
    },
    setup(props){
        const store = useStore()

        return {

        }
    },
    methods:{
        getOptionId(question, option){
            return question.id + '-' + option.id;
        }
    },
    props: {
        question: {
            type: Object
        }
    }
}
</script>
